import { useTranslation } from 'react-i18next';
import { allLangs, defaultLang } from '../config';
import i18n from '../locales/i18n';
import { TranslationKey } from 'src/@types/translation';
import { TOptions } from 'i18next';

export default function useLocales() {
  const { t, i18n: i18nFromHook } = useTranslation();

  const translate = (key: TranslationKey, options?: TOptions): string =>
    options !== undefined ? t(key, key, options) : t(key);

  const translateUnsafe = (key: string, options?: TOptions): string =>
    options !== undefined ? t(key, key, options) : t(key);
  const onChangeLang = (newLang: string) => i18n.changeLanguage(newLang);

  const currentLangCode =
    i18nFromHook?.resolvedLanguage?.split('-')[0] ||
    localStorage.getItem('i18nextLng') ||
    defaultLang.value;

  const currentLang = allLangs.find((l) => l.value === currentLangCode) || defaultLang;

  return {
    onChangeLang,
    translate,
    translateUnsafe,
    currentLang,
    allLangs,
  };
}
